import { SettingItems, SettingsTabs, ShowList, TabContent } from "modules/settings/styles"
import { useEffect, useRef, useState } from "react"
import { Modal } from "reactstrap"
import { ReactComponent as PresetIcon } from "assets/images/icons/preset-icon.svg"
import { ReactComponent as UploadFromFileIcon } from "assets/images/icons/upload-from-file.svg"
import { ReactComponent as UnsplashIcon } from "assets/images/icons/unsplash.svg"
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import { ReactComponent as UrlLinkIcon } from "assets/images/icons/url_link_black.svg"

import { BsListUl } from "react-icons/bs"
import Preset from "./Preset"
import UploadFromFile from "./UploadFromFile"
import Unsplash from "./Unspalsh"
import ImageLinkUpload from "./ImageLink"

const CoverUploadModal = ({isFullScreen, coverModal, setCoverModal, handleSubmissionOfMedia }) => {
  const [hideTemplateList, set_hideTemplateList] = useState(false);
  const [activeTab, setActiveTab] = useState('preset');
  const [page, setPage] = useState(1);

  const tabContentRef = useRef(null);

  const changeTab = (e, tab) => {
    e.preventDefault()
    setActiveTab(tab)
    set_hideTemplateList(true)
  }

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = tabContentRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 10 ) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    tabContentRef?.current?.addEventListener('scroll', handleScroll);
    return () => {
      tabContentRef?.current?.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
      <Modal zIndex={isFullScreen? '30000000000': '20'} centered fade={false} isOpen={coverModal} className='modal-lg modal-xl' toggle={() => setCoverModal()}>
        {hideTemplateList && (
          <ShowList
            href='/'
            onClick={(e) => {
              e.preventDefault()
              set_hideTemplateList(false)
            }}>
            <BsListUl /> Menu
          </ShowList>
        )}
        <div className='d-flex justify-content-between'>
          <TabContent className={hideTemplateList ? 'hideTemplateList' : ''} ref={tabContentRef} onScroll={handleScroll}>
            {activeTab === 'preset' && <Preset handleSubmissionOfMedia={handleSubmissionOfMedia} />}
            {activeTab === 'uploadFromFile' && <UploadFromFile handleSubmissionOfMedia={handleSubmissionOfMedia} />}
            {activeTab === 'unsplash' && <Unsplash handleSubmissionOfMedia={handleSubmissionOfMedia} page={page} setPage={setPage} />}
            {activeTab === 'imageLink' && <ImageLinkUpload handleSubmissionOfMedia={handleSubmissionOfMedia} setCoverModal={setCoverModal} />}
          </TabContent>

          <SettingsTabs className={`${hideTemplateList ? 'hideTemplateList' : ''}`}>
            <a
              href='/'
              className='modal-close'
              onClick={(e) => {
                e.preventDefault()
                setCoverModal(false)
              }}>
              <CloseIcon />
            </a>

            <div className='title'>Image</div>
            <SettingItems boldActive={false}>
              <li className={activeTab === 'preset' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'preset')}>
                  <PresetIcon />
                  <span>Presets</span>
                </a>
              </li>
              <li className={activeTab === 'uploadFromFile' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'uploadFromFile')}>
                  <UploadFromFileIcon />
                  <span>Upload from files</span>
                </a>
              </li>
              <li className={activeTab === 'unsplash' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'unsplash')}>
                  <UnsplashIcon />
                  <span>Pexels</span>
                </a>
              </li>
              <li className={activeTab === 'imageLink' ? 'active' : ''}>
                <a href='/' onClick={(e) => changeTab(e, 'imageLink')}>
                  <UrlLinkIcon />
                  <span>Image link</span>
                </a>
              </li>
            </SettingItems>
          </SettingsTabs>
        </div>
      </Modal>
    </>
  )
}

export default CoverUploadModal